<template>
<div class="container-fluid ">
    <div class="row">
        <div class="col-12 text-center">
            <h1>Detail Training Report</h1>
        </div>
    </div>
    <div class="row justify-content-between mb-1">
        <div class="col-4">
            <button class="btn btn-primary" @click="addPage">Add New Page</button>
        </div>

        <div class="col-4 text-right">
            <button class="btn btn-primary" @click="printPage">Print to PDF</button>
        </div>
    </div>
    <div id="pagesContainer">
        <div v-for="(page, pageIndex) in pages" :key="pageIndex" class="a4-page" :id="'page' + (pageIndex + 1)">
            <div v-if="pageIndex === 0">
                <div class="row  justify-content-between">
                    <div class="col-4 ml-3 pt-3">
                        <img :src="imageSrc" alt="" width="350" />
                    </div>
                    <div class="col-4 text-right mr-3 pt-3" style="font-weight: 700;">
                        Country Office Pakistan<br />Monitoring & Evaluation Unit
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-6 text-center rep-text">
                        Training Analysis Report
                    </div>
                </div>

                <div class="row ml-2">
                    <div class="col-12">
                        <h3 class="cl-b">
                            {{ trainingDetails.title }}
                        </h3>
                    </div>
                    <div class="col-12 cl-b">
                        <h6>Event Brief Information</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <template v-if="
                trainingDetails != '' &&
                  trainingDetails.district != undefined 
              ">
                                        <th scope="col">Country</th>
                                        <td>
                                            {{ trainingDetails.district.province.country.title }}
                                        </td>
                                        <th scope="col">Province</th>

                                        <td>{{ trainingDetails.district.province.title }}</td>

                                        <th scope="col">City</th>
                                        <td>{{ trainingDetails.district.title }}</td>
                                    </template>
                                    <template v-else>
                                        <th scope="col">Country</th>
                                        <td>No country added</td>
                                        <th scope="col">Province</th>

                                        <td>No province added</td>

                                        <th scope="col">City</th>
                                        <td>No City added</td>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">Advisor</th>
                                    <td>{{ trainingDetails.advisor.name }}</td>
                                    <th scope="row">Program Officer</th>
                                    <td>{{ trainingDetails.programofficer.name }}</td>
                                    <th scope="row">Donor</th>
                                    <td>
                                        <template v-for="(doner) in doners">
                                            {{ doner.title }}
                                        </template>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Start Date</th>
                                    <td>{{ trainingDetails.startdate }}</td>
                                    <th scope="row">End Date</th>
                                    <td>{{ trainingDetails.enddate }}</td>
                                    <th scope="row">No. of Days</th>
                                    <td>{{ trainingDetails.noofdays }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Sub Programme/Project</th>
                                    <td colspan="5">{{ trainingDetails.subprogram.title }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Trainers</th>
                                    <td colspan="5">
                                        <template v-for="(trainer) in alltrainers">
                                            {{ trainer.trainer.name }} ,</template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 cl-b ml-3 rep-text">
                        Detailed Overall Training Analysis
                    </div>

                    <div class="col-12 department">
                        <div class="row">
                            <div class="col-6">
                                <table class="table table-bordered mb-1">
                                    <thead>
                                        <tr>
                                            <th>Departments</th>
                                            <th>No</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(depart, dida) in departmentReport.Dreport" :key="dida">
                                            <td style="padding:0rem 0.75rem">
                                                {{ depart.title }}
                                            </td>
                                            <td style="padding:0rem 0.75rem">
                                                {{ depart.count }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style="padding:0rem 0.75rem">Other</td>
                                            <td style="padding:0rem 0.75rem">
                                                {{ departmentReport.other }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="col-6">
                                <table class="table table-bordered mb-1">
                                    <thead>
                                        <tr>
                                            <th>Participants Designation</th>
                                            <th>No</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(desig, kajds) in designationReport.DesignationReport" :key="kajds">
                                            <td style="padding:0rem 0.75rem">{{ desig.title }}</td>
                                            <td style="padding:0rem 0.75rem">{{ desig.count }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding:0rem 0.75rem">Other</td>
                                            <td style="padding:0rem 0.75rem">
                                                {{ designationReport.other }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!--
            <div class="col-5 gender">
              <canvas id="genderChart"></canvas>
            </div>
            <div class="col-5 knowledge">
              <canvas id="knowledgeChart"></canvas>
            </div>
            -->
                </div>
            </div>

            <div v-for="(chart, chartIndex) in page.charts" :key="chartIndex" class="chart-container" :id="'chart' + (pageIndex + 1) + '-' + (chartIndex + 1)">
                <button class="delete-btn" @click="removeChart(pageIndex, chartIndex)">
                    ×
                </button>
                <h4>{{ chart.questionTitle }}</h4>
                <canvas :id="'chartCanvas' + (pageIndex + 1) + '-' + (chartIndex + 1)"></canvas>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/themes/base/all.css';

export default {
    data() {
        return {
            pages: [{
                charts: [],
            }, ],

            trainingDetails: [],
            doners: [],
            alltrainers: [],
            imageSrc: require('@/assets/unodc_logo.png'),
            departmentReport: [],
            designationReport: [],
        };
    },

    mounted() {
        this.trainingDetails = JSON.parse(localStorage.getItem('trainingDetails'));
        this.doners = JSON.parse(localStorage.getItem('doners'));
        this.alltrainers = JSON.parse(localStorage.getItem('alltrainers'));
        this.departmentReport = JSON.parse(localStorage.getItem('departmentReport'));
        this.designationReport = JSON.parse(localStorage.getItem('designationReport'));

        this.genderReport = JSON.parse(localStorage.getItem('genderReport'));
        this.knowledgeReport = JSON.parse(localStorage.getItem('knowledgeReport'));
        this.StandardQuestions = JSON.parse(localStorage.getItem('StandardQuestions'));
        this.StandardPostQuestions = JSON.parse(localStorage.getItem('StandardPostQuestions'));

        if (this.genderReport) {
            this.pages[0].charts.push(this.genderReport);
        }

        if (this.knowledgeReport) {
            this.pages[0].charts.push(this.knowledgeReport);
        }

        if (this.StandardQuestions && Array.isArray(this.StandardQuestions)) {
            this.StandardQuestions.forEach(question => {
                this.pages[0].charts.push(question);
            });
        }

        if (this.StandardPostQuestions && Array.isArray(this.StandardPostQuestions)) {
            this.StandardPostQuestions.forEach(postQuestion => {
                this.pages[0].charts.push(postQuestion);
            });
        }
        setTimeout(() => {
            this.initializeCharts(0);
        }, 1000);
    },
    methods: {

        initializeCharts(pageIndex) {

            // Initialize each chart on the given page
            this.pages[0].charts.forEach((data, chartIndex) => {
                this.initializeChart(data, pageIndex, chartIndex);
            });
        },
        initializeChart(data, pageIndex, chartIndex) {
            this.$nextTick(() => {
                let chartType = '';
                let colors = [];

                if (data.label.length === 2) {
                    if (data.type === 'bar') {
                        chartType = 'bar';
                        colors = ['#80ff80', '#63b94b'];
                    } else {
                        chartType = 'pie';
                        colors = ['#4774B8', '#EA7D3A'];
                    }
                } else if (data.label.length === 3) {
                    chartType = 'bar';
                    colors = ['#cc0000', '#ffd633', '#0099cc'];
                } else if (data.label.length === 4) {
                    chartType = 'bar';
                    colors = ['#D1324E', '#EF522F', '#FEC447', '#6AAA4A'];
                } else if (data.label.length === 5) {
                    chartType = 'bar';
                    colors = ['#D1324E', '#EF522F', '#FEC447', '#6AAA4A', '#218FCE'];
                }

                const ctx = document.getElementById(`chartCanvas${pageIndex + 1}-${chartIndex + 1}`).getContext('2d');

                const total = data.Options.reduce((sum, val) => sum + val, 0);
                const percentageData = data.Options.map(value => (value / total) * 100);

                const chart = new Chart(ctx, {
                    type: chartType,
                    data: {
                        labels: data.label,
                        datasets: [{
                            label: data.questionTitle,
                            data: percentageData,
                            backgroundColor: colors,
                            categoryPercentage: .9,
                            // minBarLength: 0,

                        }],
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    // beginAtZero: true, // Start Y-axis at 0
                                    min: 0,
                                    max: 100, // Set Y-axis maximum to 100
                                    stepSize: 20 // Adjust step size as needed
                                },

                            }]
                        },
                        plugins: {
                            datalabels: {
                                formatter: (value) => {
                                    return Math.round(value) + '%';

                                },
                                color: '#fff',
                                font: {
                                    weight: 'bold',
                                    size: 10,
                                },
                            },
                        },

                    },
                    plugins: [ChartDataLabels],
                });

                const chartSelector = `#chart${pageIndex + 1}-${chartIndex + 1}`;
                $(chartSelector).draggable({
                    containment: "#pagesContainer",
                    stack: ".chart-container",
                }).resizable({
                    containment: "#pagesContainer",
                    handles: "se",
                    resize(event, ui) {
                        const canvas = $(this).find("canvas");
                        if (canvas.length) {
                            canvas.css({
                                width: ui.size.width + "px",
                                height: ui.size.height + "px",
                            });
                            chart.resize(); // Resize the stored chart instance
                        }
                    }
                });
            });
        },

        addPage() {
            // Add a new page and initialize the charts on that page
            this.pages.push({
                charts: []
            });
            this.initializeCharts(this.pages.length - 1); // Initialize the charts for the new page
        },
        removeChart(pageIndex, chartIndex) {
            // Remove a chart from a specific page
            this.pages[pageIndex].charts.splice(chartIndex, 1);
            setTimeout(() => {
                this.initializeCharts(0);
            }, 500);
        },
        printPage() {
            // Print the page to PDF
            window.print();
        }
    }

};
</script>
<!--

<style>
.container {
    padding: 20px;
}

header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.a4-page {
    width: 100%;
    height: 410mm;
    border: 1px solid #000;
    margin-bottom: 20px;
    position: relative;
    background-color: white;
}

.chart-container {
    position: absolute;
    width: 400px;
    height: 400px;
    border: 1px solid #ccc;
    background: #f9f9f9;
    padding: 10px;
    border-radius: 5px;
    transition: box-shadow 0.3s ease;
}

.chart-container:hover {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
    /* Apply box shadow on hover */
}

.delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    background-color: red;
    color: white !important;
    ;
    border: none;
    cursor: pointer;
    width: 25px;
    height: 35px;
    display: none;
}

.chart-container:hover .delete-btn {
    display: block;
    /* Show the button when hovering over the chart container */
}

.text-right {
    text-align: right;
}

.rep-text {
    font-weight: 600;
    font-size: 22px;
    color: #00a4ea;
}

.cl-b {
    color: #00a4ea;
}

@media print {
    body * {
        visibility: hidden;
    }

    #pagesContainer,
    #pagesContainer * {
        visibility: visible;
    }

    #pagesContainer {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }
}
</style>
-->
